import { defineSlotRecipe } from '@chakra-ui/react';

export const sectionTitleSlotRecipe = defineSlotRecipe({
	slots: [ 'root', 'text' ],

	base: {
		root: {
			bg: 'primary.100',
			px: 'md',
			py: 'sm',
		},
		text: {
			color:     'white',
			textStyle: 'h3',
		},
	},
});
